import { useAppAbility } from '@/hooks/useAppAbility';
import { Action } from '@/services/api';
import { SubjectEntity } from '@/setup/casl';

export const useIsFieldDisabled = <T extends SubjectEntity>(entity?: T) => {
  const ability = useAppAbility();

  return (field: keyof T & string) => !entity || ability.cannot(Action.UPDATE, entity, field);
};
